
const RestaurantMenuShimmer = () => {
    return (
      <div className="animate-pulse">
        {/* Mock Restaurant Summary */}
        <section className="animate-pulse flex flex-col p-4 mb-6 bg-slate-100 sm:flex-row sm:justify-center sm:h-72">
          <div className="bg-slate-200 h-60 rounded-lg sm:w-72 sm:h-full"></div>
          <section className="sm:w-96 sm:px-4">
            <div className="h-6 bg-slate-200 w-1/2 my-2 rounded-lg"></div>
            <div className="h-6 bg-slate-200 w-1/4 my-1 rounded-lg"></div>
            <div className="h-6 bg-slate-200 w-1/4 my-1 rounded-lg"></div>
            <div className="h-16 w-1/4 bg-slate-200 my-6 rounded-lg"></div>
            <div className="flex justify-between w-full h-6">
              <span className="w-1/4 bg-slate-200 rounded-lg"></span>
              <span className="w-1/4 bg-slate-200 rounded-lg"></span>
            </div>
          </section>
        </section>

        {/* Mock Item card */}
        <article className="flex my-2 bg-slate-100 rounded-lg p-2 h-36 w-11/12 md:w-4/5 lg:w-3/5 mx-auto">
          <section className="px-2 basis-4/5">
            <div className="h-6 bg-slate-200 w-1/2 my-2 rounded-lg"></div>
            <div className="h-6 w-1/5 bg-slate-200 rounded-lg"></div>
            <div className="h-10 bg-slate-200 w-3/4 my-2 rounded-lg"></div>
          </section>
          <div className="rounded-lg basis-1/5 h-full bg-slate-200"></div>
        </article>

      </div>
    );
}

export default RestaurantMenuShimmer;   